import React, { Component } from 'react';
import PageWrapper from '@/components/PageWrapper';
import LoginForm from './LoginForm';
import styles from './index.less';

class Welcome extends Component {
    render() {
        return (
            <div className={styles.loginWrap}>
                <div className={styles.bgWrap}>
                    <img src="//singleunit.oss-cn-hangzhou.aliyuncs.com/f2e/752377fc1470d80f1512935b4b2ba9cc.png@100p" />
                </div>
                <div className={styles.container}>
                    <div className={styles.logo}><img src="//singleunit.oss-cn-hangzhou.aliyuncs.com/f2e/d295ab322acccef29450c71a982714fa.png"/></div>
                    <div className={styles.content}>
                        <div className={styles.leftWrap}>
                            <div className={styles.txt1}>大搜车超级4S<br />新零售场景数字化解决方案</div>
                            <div className={styles.txt2}>智能、科技、数据、未来</div>
                            <div className={styles.btns}>
                                <div className={styles.btn}>
                                    <div>IOS版</div>
                                    <div className={styles.qcode}>
                                        {/* <img alt="下载大搜车集团版 IOS APP" src="//img.souche.com/bolt/FDPGD22Bfx02ePSKQN0Ax/rqEucThfAqqAev0q634yT..png"/> */}
                                        {/* <img alt="下载大搜车集团版 IOS APP" src="//souche.oss-cn-hangzhou.aliyuncs.com/e746a89a-77af-4c13-a56d-d5910d23c1f41685697462783.png"/> */}
                                        {/* <img alt="下载大搜车集团版 IOS APP" src="http://souche.oss-cn-hangzhou.aliyuncs.com/20240524/png/079576d0872dc26b4ed5ef4b7465c8da.png"/> */}
                                        <img alt="下载大搜车集团版 IOS APP" src="http://singleunit.oss-cn-hangzhou.aliyuncs.com/20241016/png/23e4d4248f065108d1ec4f8a6eeec556.png"/>
                                    </div>
                                </div>
                                <div className={styles.btn}>
                                    <div>安卓版</div>
                                    <div className={styles.qcode}>
                                        {/* <img alt="下载大搜车集团版 Android APP" src="//img.souche.com/bolt/FDPGD22Bfx02ePSKQN0Ax/rqEucThfAqqAev0q634yT..png"/> */}
                                        {/* <img alt="下载大搜车集团版 Android APP" src="//img.souche.com/f2e/bb90e0d571d3ec810f7739b705535b33.png"/> */}
                                        {/* <img alt="下载大搜车集团版 Android APP" src="//souche.oss-cn-hangzhou.aliyuncs.com/20240419/png/40327045264cfad480afbcf75b72f3eb.png"/> */}
                                        <img alt="下载大搜车集团版 Android APP" src="http://singleunit.oss-cn-hangzhou.aliyuncs.com/20241016/png/88571589405e82aa2a5b79474a48014c.png"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightWrap}>
                            <p className={styles.text}>登录</p>
                            <LoginForm/>
                        </div>
                    </div>
                </div>
                <div className={styles.footer}>Copyright © 2015 SouChe All Rights Reserved</div>
            </div>
        );
    }
}

export default Welcome;
